import { CryptoSwapsService } from "../services/cryptoSwaps.service";
import type { OtcPair } from "../types/cryptoSwaps.types";
import { createOtcPairsCatalog, type UseOtcPairsResult } from "./otcPairsCatalog";

const catalog = createOtcPairsCatalog<OtcPair>((organizationId) =>
  CryptoSwapsService.listPairs(organizationId),
);

export const invalidateCryptoSwapPairs = catalog.invalidate;

export type UseCryptoSwapPairsResult = UseOtcPairsResult<OtcPair>;

/** The purchase catalog. */
export function useCryptoSwapPairs(organizationId: string | null): UseCryptoSwapPairsResult {
  return catalog.usePairs(organizationId);
}
